import ArrowBack from '@mui/icons-material/ArrowBack';
import { Button } from '@src/common/components/button/Button';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick?: () => void;
  label?: string;
};

export const BackButton = ({ onClick, label }: Props) => {
  const { t } = useTranslation();
  return (
    <Button
      size="small"
      variant="text"
      onClick={onClick}
      startIcon={<ArrowBack />}
      style={{ padding: '8px 4px' }}
    >
      {label ?? t('back')}
    </Button>
  );
};
